/* Restaurantware - First Order Pop-up ($10 OFF).
   Opens once per browser after data-delay ms. CSS, font and images load only when it opens.
   Test helpers: window.RWFirstOrderPopup.open() / .close() / .reset() */
(function () {
  'use strict';

  var KEY = 'rw_first_order_popup_seen';
  var FONT_URL = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap';
  var tpl = document.getElementById('rwpTemplate');
  if (!tpl) return;

  var cfg = {
    css: tpl.getAttribute('data-css'),
    delay: parseInt(tpl.getAttribute('data-delay'), 10) || 5000,
    companyId: tpl.getAttribute('data-company-id') || '',
    listId: tpl.getAttribute('data-list-id') || '',
    checkUrl: tpl.getAttribute('data-check-url') || ''
  };
  var ov = null;
  var box = null;
  var lastFocus = null;
  var assetsReady = null;

  function seen() {
    try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }

  function markSeen() {
    try { localStorage.setItem(KEY, '1'); } catch (e) { /* storage blocked */ }
  }

  function addLink(href) {
    return new Promise(function (resolve) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = link.onerror = function () { resolve(); };
      document.head.appendChild(link);
      setTimeout(resolve, 3000); // never block the pop-up on a slow font/css request
    });
  }

  function loadAssets() {
    if (!assetsReady) assetsReady = Promise.all([addLink(cfg.css), addLink(FONT_URL)]);
    return assetsReady;
  }

  // Required mobile number -> E.164 (US numbers default to +1). Returns null when blank or invalid.
  function normalizePhone(raw) {
    var digits = raw.replace(/\D/g, '');
    if (raw.trim().charAt(0) === '+') return digits.length >= 8 && digits.length <= 15 ? '+' + digits : null;
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    return null;
  }

  function subscribe(email, phone) {
    if (!cfg.companyId || !cfg.listId) {
      console.warn('[RW first-order pop-up] Klaviyo company id / list id not set - email NOT sent.');
      return Promise.resolve();
    }
    // Klaviyo client API: adding the profile to the list is the email subscription
    // ("subscriptions" is not a valid profile field on this endpoint).
    var profileAttrs = { email: email };
    if (phone) profileAttrs.phone_number = phone;
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'First Order Pop-up',
          profile: { data: { type: 'profile', attributes: profileAttrs } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.listId } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo responded ' + res.status);
    });
  }

  // "Already in use" check against the Klaviyo list (server endpoint holds the private key).
  // If no endpoint is configured or it is down, the sign-up goes through as before.
  function checkExisting(email, phone) {
    if (!cfg.checkUrl) return Promise.resolve({});
    return fetch(cfg.checkUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, phone: phone })
    })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .catch(function () { return {}; });
  }

  function onSubmit(e) {
    e.preventDefault();
    var input = ov.querySelector('#rwpEmail');
    var err = ov.querySelector('#rwpErr');
    var btn = ov.querySelector('.rwp-cta');
    var phoneInput = ov.querySelector('#rwpPhone');
    var email = input.value.trim();
    var phone = normalizePhone(phoneInput.value);
    var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
    var phoneOk = phone !== null;
    input.classList.toggle('is-error', !emailOk);
    phoneInput.classList.toggle('is-error', !phoneOk);
    err.textContent = emailOk ? 'Please enter a valid mobile number.' : 'Please enter a valid email address.';
    err.style.display = emailOk && phoneOk ? 'none' : 'block';
    if (!emailOk || !phoneOk) return;
    btn.disabled = true;
    checkExisting(email, phone).then(function (res) {
      var msgs = [];
      if (res.emailUsed) { msgs.push('This email is already in use.'); input.classList.add('is-error'); }
      if (res.phoneUsed) { msgs.push('This phone number is already in use.'); phoneInput.classList.add('is-error'); }
      if (msgs.length) {
        err.innerHTML = msgs.join('<br>');
        err.style.display = 'block';
        btn.disabled = false;
        return;
      }
      return subscribe(email, phone).then(function () {
        box.classList.add('is-done');
        markSeen();
      });
    }).catch(function () {
      btn.disabled = false;
      err.textContent = 'Something went wrong. Please try again.';
      err.style.display = 'block';
    });
  }

  function onKeydown(e) {
    if (!ov || !ov.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var nodes = Array.prototype.filter.call(
      ov.querySelectorAll('a[href], button, input'),
      function (n) { return !n.disabled && n.offsetParent !== null; }
    );
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function build() {
    if (ov) return;
    document.body.appendChild(tpl.content.cloneNode(true));
    ov = document.getElementById('rwpOverlay');
    box = document.getElementById('rwp');
    ov.addEventListener('click', function (e) {
      if (e.target === ov || e.target.hasAttribute('data-rwp-close')) close();
    });
    ov.querySelector('#rwpForm').addEventListener('submit', onSubmit);
    document.addEventListener('keydown', onKeydown);
  }

  function open() {
    loadAssets().then(function () {
      build();
      lastFocus = document.activeElement;
      ov.classList.add('is-open');
      ov.querySelector('#rwpEmail').focus();
    });
  }

  function close() {
    if (!ov) return;
    ov.classList.remove('is-open');
    markSeen();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function reset() {
    try { localStorage.removeItem(KEY); } catch (e) { /* storage blocked */ }
  }

  window.RWFirstOrderPopup = { open: open, close: close, reset: reset };

  if (!seen()) setTimeout(open, cfg.delay);
})();
